
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/bestie",
      function () {
        return require("private-next-pages/[locale]/bestie/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/bestie"])
      });
    }
  